import { ApiService } from 'src/app/providers/api.service';
import { Component, Inject, NgZone, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { LoaderServiceService } from 'src/app/providers/loader-service.service';
import { Subscription } from 'rxjs';
import { SM_CONSTANTS } from 'src/app/shared/constants/sm-constants';
import { CustomConfirmDialogComponent } from 'src/app/shared/components/custom-confirm-dialog/custom-confirm-dialog.component';

@Component({
  selector: 'sm-add-unavailability-settings',
  templateUrl: './add-unavailability-settings.component.html',
  styleUrls: ['./add-unavailability-settings.component.scss']
})
export class AddUnavailabilitySettingsComponent implements OnInit,OnDestroy{
  today: string = this.formatDate1(new Date());
  fromtime:any
  totime:any
  notes:any
  fromDate:any
  toDate:any
  apisub:Subscription
  @ViewChild('toDateInput') toDateInput: any;
  constructor(private ngzone:NgZone,private dialog:MatDialog,@Inject(MAT_DIALOG_DATA) public parentdata:any, private ls: LoaderServiceService, private apiservice: ApiService, private activemodal: MatDialogRef<AddUnavailabilitySettingsComponent>){
    this.apisub = this.apiservice.apiResult.subscribe(resdata => {
      if(resdata.responseType === SM_CONSTANTS.RESULT_API_SET_UNAVAILABILITY_FOR_ENTITY){
        this.activemodal.close({
          msg: 'success'
        })
      }
    })
  }

  ngOnInit(): void {
    console.log(this.parentdata);
    
  }


  formatDate1(dateStr: Date) {
    console.log(dateStr);
    
    let curdate = new Date(dateStr)
      .toLocaleString("en-CA", {
        timeZone: "Asia/Kolkata",
        year: "numeric",
        month: "2-digit",
        day: "2-digit",
      })
      .slice(0, 10);
    console.log(curdate);

    return curdate;
  }


  generateDateArray(fromDate:any, toDate:any, fromTime:any, toTime:any, notes:any) {
    const result = [];
    const currentDate = new Date(this.formatDate1(fromDate));
    const endDate = new Date(this.formatDate1(toDate));

    while (currentDate <= endDate) {
        result.push({
            date: this.formatDate1(currentDate),
            from_time: fromTime,
            to_time: toTime,
            notes: notes ?? '',
            service_type: +this.parentdata.serviceType
        });

        // Move to next day
        currentDate.setDate(currentDate.getDate() + 1);
    }

    return result;
}

convertTo24HourFormat(time:any) {
  // Extract hours, minutes, and AM/PM from the time string
  const [timePart, amPm] = time.split(' ');
  const [hoursStr, minutesStr] = timePart.split(':');

  // Convert string components to numbers
  let hours = parseInt(hoursStr, 10);
  const minutes = parseInt(minutesStr, 10);

  // Adjust hours based on AM/PM
  if (amPm.toLowerCase() === 'pm' && hours !== 12) {
      hours += 12;
  } else if (amPm.toLowerCase() === 'am' && hours === 12) {
      hours = 0;
  }

  // Construct a new Date object with a fixed date and the parsed time components
  const date = new Date(2000, 0, 1, hours, minutes);

  // Use Date methods to get hours, minutes, and seconds in 24-hour format
  const formattedHours = date.getHours().toString().padStart(2, "0");
  const formattedMinutes = date.getMinutes().toString().padStart(2, "0");

  const formattedTime = `${formattedHours}:${formattedMinutes}`;

  console.log(formattedTime);

  return formattedTime;
}


onSave(){
  let bodydata = this.generateDateArray(this.formatDate1(this.fromDate),this.formatDate1(this.toDate),this.convertTo24HourFormat(this.fromtime),this.convertTo24HourFormat(this.totime),this.notes)
  console.log(bodydata);
  
  this.ls.showLoader = true
  this.apiservice.setUnavailabilityForEntity(bodydata,this.parentdata.entityHash)

}

validateDateRange() {
  if (!this.fromDate || !this.toDate) {
    return;
  }

  const from = new Date(this.formatDate1(this.fromDate));
  const to = new Date(this.formatDate1(this.toDate));

  // Calculate difference in milliseconds
  const diffInMs = to.getTime() - from.getTime();

  // Calculate difference in days
  const diffInDays = diffInMs / (1000 * 60 * 60 * 24);

  if (diffInDays > 6) {  
    this.ngzone.run(()=>{
      this.toDate = null;
      this.toDateInput.reset(); 
    })
    console.log(this.toDate);
    
      const dialogRef = this.dialog.open(CustomConfirmDialogComponent,{
              data : {
                title : 'Alert',
                message : 'You can select a maximum range of 7 days only.',
                okbtn : 'Ok',
                cancelbtn : 'Cancel',
                type : SM_CONSTANTS.CUSTOM_DIALOG_ALERT_TYPE
              },
              disableClose : true
            });
  }
  else if (diffInDays < 0) {
    this.ngzone.run(()=>{
      this.toDate = null;
      this.toDateInput.reset(); 
    })
    const dialogRef = this.dialog.open(CustomConfirmDialogComponent,{
      data : {
        title : 'Alert',
        message : 'To Date cannot be earlier than From Date.',
        okbtn : 'Ok',
        cancelbtn : 'Cancel',
        type : SM_CONSTANTS.CUSTOM_DIALOG_ALERT_TYPE
      },
      disableClose : true
    });
  }
}

ngOnDestroy(): void {
  this.apisub.unsubscribe()
}
}
